<template>
  <section>
    <form class="columns local-lm-filters-columns">
      <div class="column is-1">
        <order-number-filter />
      </div>
      <div class="column is-4">
        <b-field>
          <b-datepicker
            :placeholder="$t('Orders.datePlaceholder')"
            icon="calendar-month"
            v-model="deliveryDates[0]"
            class="local-lm-filters-datepicker"
            range
          />
        </b-field>
      </div>
      <div class="column is-1 local-lm-limit-width">
        <b-button
          class="lm-default-btn-outline-green--without-width lm-default-btn-delete"
          icon-right="close"
          size="is-small"
          @click.prevent="cleanFilters"
        />
        <b-button
          class="lm-default-btn-outline-green--without-width"
          icon-right="magnify"
          size="is-small"
          @click.prevent="submitData"
        />
      </div>
    </form>
  </section>
</template>

<script>
import { mixin } from '@/mixins'
import OrderNumberFilter from '@/components/filters/OrderNumberFilter'

export default {
  name: 'OrderFilters',
  beforeDestroy () {
    this.$eventBus.$off('orders')
    this.$eventBus.$off('sortOrders')
    this.$eventBus.$off('closeModal')
    this.$eventBus.$off('onPageChange')
    this.$eventBus.$off('cleanFilters')
  },
  mixins: [
    mixin.notifications,
    mixin.dates
  ],
  data () {
    return {
      deliveryDates: []
    }
  },
  components: {
    OrderNumberFilter
  },
  mounted () {
    this.$eventBus.$on('sortOrders', async (sortOption) => {
      this._getOrders(sortOption)
    })

    this.$eventBus.$on('closeModal', async () => {
      this._getOrders()
    })

    this.$eventBus.$on('onPageChange', async (page) => {
      this.$store.dispatch('filters/setPage', page)
      this._getOrders()
    })
  },
  methods: {
    async _getOrders (sort = null) {
      const filters = await this.$store.getters['filters/filtersSelected']
      if (sort) filters.sort = sort

      const orders = await this.$store.dispatch('orders/getOrders', { filters })
      if (!orders.level) return this.wrong(this.$t(orders.errorText))

      const lengthOrders = this.$store.getters['orders/orders']
      if (orders && lengthOrders.length === 0) {
        this.$eventBus.$emit('emptyOrders')
      }

      if (orders && lengthOrders.length) {
        this.$eventBus.$emit('orders')
      }
    },

    async submitData () {
      this.$store.dispatch('filters/resetPage')

      if (this.deliveryDates.length) {
        const flattenedArray = [].concat(...this.deliveryDates)
        const dates = {
          deliveryDateBegin: this.dateTimestamp(flattenedArray[0]),
          deliveryDateEnd: this.dateTimestamp(flattenedArray[1])
        }
        this.$store.dispatch('filters/setDeliveryDateSelected', dates)
      }

      this._getOrders()
    },
    cleanFilters () {
      this.deliveryDates = []
      this.$store.dispatch('filters/flushUserFilters')
      this.$store.dispatch('orders/flush')

      this.$eventBus.$emit('cleanFilters')
      this.$eventBus.$emit('orders')
      this._getOrders()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/filters/OrderFilters.vue